<div class="container position-relative portailrh-container-page">
  <div class="row">
    <div class="col-12">
      <h2 class="mb-4">Sélectionner un collaborateur</h2>

    </div>
  </div>
  <app-filters provenance="maj-manager"></app-filters>
  <app-list></app-list>
</div>
